/** @jsx h */

import { h } from 'preact';
import classes from './new-product-intro-card.module.css';
import { Checkmark } from '../checkmark';
import '@updater-components/pill';
import '@updater-components/cta';
import '@updater-components/icon';
import '@updater-components/card';

const when = (bool, fn) => (bool ? fn() : '');

export const NewProductIntroCard = props => (
  <upd-card
    class={[
      classes.card,
      props.mode === 'ACTIVE' ? classes.active : '',
      props.mode === 'MOBILE' ? classes.mobile : '',
      props.mode === 'DEFAULT' ? classes.default : '',
    ].join(' ')}
    onmouseenter={() => props.handleEnterCard(props.index)}
    onmouseleave={() => props.handleLeaveCard()}
  >
    {when(props.page && props.page.required, () => (
      <div class={classes['ribbon-container']}>
        <div class={classes.ribbon}>REQUIRED</div>
      </div>
    ))}
    <div class={classes.header}>
      <div class={classes['pill-container']}>
        <upd-pill
          class={[classes.pill, props.mode === 'ACTIVE' ? 'solid' : ''].join(
            ' '
          )}
          text={props.callout}
          name="clock"
        />
      </div>
      <div class={classes['icon-container']}>
        <upd-icon class={classes.icon} name={props.icon} />
      </div>
      <div
        class={[
          classes.title,
          props.titleClass ? classes[props.titleClass] : '',
        ].join(' ')}
      >
        {props.title}
      </div>
      <div class={classes.bonus}>
        {{
          html: props.bonus,
        }}
      </div>
    </div>
    <div class={classes.body}>
      <div class={classes.bullets}>
        {props.bullets.map(bullet => (
          <div class={classes.bullet}>
            <span class={classes.checkmark}>{Checkmark()}</span>
            <p class={classes.text}>{bullet}</p>
          </div>
        ))}
      </div>
    </div>
    <div class={classes.footer}>
      <upd-cta
        class={classes.cta}
        secondary={props.mode === 'DEFAULT' ? '' : null}
        primary={props.mode === 'ACTIVE' || props.mode === 'MOBILE' ? '' : null}
      >
        <button
          class={[
            classes.target,
            props.mode === 'ACTIVE' || props.mode === 'MOBILE'
              ? classes.hover
              : '',
          ].join(' ')}
          onclick={() => props.handleCardClick(props.index)}
        >
          {props.cta.label}
        </button>
      </upd-cta>
    </div>
  </upd-card>
);
